<template>
  <m-dialog ref="dlgDetailGroup" @save="save" :title="`Detil ` + grup.nama" :fullscreen="false">
    <v-row>
      <v-col cols="12" sm="12" md="2" lg="2">
        <v-icon color="primary" size="100">mdi-google-classroom</v-icon>
      </v-col>
      <v-col cols="12" sm="12" md="10" lg="10">
        <span class="title primary--text">{{ pVal(grup.gruping, "nama") }}</span>
        <p class="title">{{ pVal(grup, "nama") }}</p>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <ListAnggota :items="grup.member" :group="grup" @load="load" />
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import ListAnggota from "../../kelas/components/ListAnggotaGroup.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    ListAnggota
  },
  props: {
    grouping: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      grup: {},
      defGrup: {
        nama: ""
      }
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      // this.grup = obj ? { obj } : { ...this.defGrup };
      this.grup = obj;
      let x = this.$refs.dlgDetailGroup.open();
      this.$validator.reset();
      return x;
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("kelas/addGrup", {
              instansi_id: this.instansi_id,
              diklat_id: this.diklat_id,
              kelas_id: this.kelas_id,
              obj: this.grup
            })
            .then(res => {
              this.$emit("load");
              this.$refs.dlgDetailGroup.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    },
    load() {
      this.$emit("load");
    }
  },

  computed: {
    kelasmodul() {
      return this.$store.getters["kelas/grouping"];
    }
  },
  watch: {
    kelasmodul(n) {
      n.forEach(kelasmodul => {
        kelasmodul.gruping.forEach(grouping => {
          grouping.grup.forEach(grup => {
            if (grup.id == this.grup.id) {
              this.grup = grup;
              return;
            }
          });
        });
      });
    }
  }
};
</script>
